import { useState } from "react";
import { Skeleton } from "antd";
import type { Texture } from "@textureninja/shared";
import { useLatestTextures } from "@/lib/queries.js";
import { Gallery } from "@/features/gallery/Gallery.js";
import { TextureModal } from "@/features/gallery/TextureModal.js";

export function LatestTextures() {
  const { data, isLoading } = useLatestTextures();
  const [openModal, setOpenModal] = useState<Texture | null>(null);

  return (
    <div>
      <div className="tn-section-header">
        <h2>Recently added</h2>
        <span className="tn-section-sub">Latest uploads to the archive</span>
      </div>
      <div
        style={{
          padding: 6,
          background: "rgba(0, 0, 0, 0.25)",
          border: "1px solid var(--tn-border-faint)",
          borderRadius: 4,
        }}
      >
        {isLoading && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 4 }}>
            {Array.from({ length: 12 }).map((_, i) => (
              <Skeleton.Image key={i} active style={{ width: "100%", height: 220 }} />
            ))}
          </div>
        )}
        {data && (
          <Gallery textures={data} onOpen={setOpenModal} maxRows={3} rowHeight={220} gutter={4} />
        )}
      </div>
      {openModal && (
        <TextureModal texture={openModal} open={true} onClose={() => setOpenModal(null)} />
      )}
    </div>
  );
}
